export default __webpack_public_path__ + "static/media/madenice.ca1e9a07.jpeg";